// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"426":"54030ad3","592":"a02da5ca","619":"6533c4ec"}[chunkId] + ".chunk.css";
};